import { useLazyQuery } from '@apollo/client';
import { showErrorToast } from '@shared/services/toastService';
import GET_OBSERVATION_REPORT_DOCUMENT_FILE_URL from '../../observationReport/queries/getObservationReportDocumentFileURLQuery';

const DOWNLOAD_FILE_ERROR_MESSAGE = 'An error occurred while fetching the download link.';

export const useObservationReportFileDownload = () => {
  const [getFileUrlQuery] = useLazyQuery(GET_OBSERVATION_REPORT_DOCUMENT_FILE_URL, {
    fetchPolicy: 'network-only'
  });

  const handleFileDownload = async (eventId, observedUserId) => {
    const { data, error: downloadError } = await getFileUrlQuery({
      variables: { eventId, observedUserId }
    });

    if (downloadError) {
      showErrorToast(DOWNLOAD_FILE_ERROR_MESSAGE);
      return;
    }

    window.open(data.observationReportFileUrl, '_blank');
  };

  return {
    handleFileDownload
  };
};
